import { render, staticRenderFns } from "./FontPermissions.vue?vue&type=template&id=f79e045c&scoped=true&"
import script from "./FontPermissions.vue?vue&type=script&lang=js&"
export * from "./FontPermissions.vue?vue&type=script&lang=js&"
import style0 from "./FontPermissions.vue?vue&type=style&index=0&id=f79e045c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79e045c",
  null
  
)

export default component.exports